import { render, staticRenderFns } from "./FormAddQuestionMarker.vue?vue&type=template&id=63134dfa&scoped=true"
import script from "./FormAddQuestionMarker.vue?vue&type=script&lang=js"
export * from "./FormAddQuestionMarker.vue?vue&type=script&lang=js"
import style0 from "./FormAddQuestionMarker.vue?vue&type=style&index=0&id=63134dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63134dfa",
  null
  
)

export default component.exports